export default {
  getAllProfilesPreviews: state => {
    return state.profilePreviews
  },
}
